import React, { useEffect, useState } from "react";
import api from "../api/api";
import "../styles/contact.css";

export default function Contact() {
  const [contact, setContact] = useState(null);
  const [loadingContact, setLoadingContact] = useState(true);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const res = await api.get("contact/details/");
        if (res.data && res.data.length > 0) {
          setContact(res.data[0]);
        }
      } catch (err) {
        console.error("Contact API Error:", err);
      } finally {
        setLoadingContact(false);
      }
    };
    fetchContact();
  }, []);

  if (loadingContact) {
    return <p className="contact-loading">Loading contact info...</p>;
  }

  const locationName = "Shree Sharada Mata Public School";
  const locationMapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationName)}`;

  return (
    <div className="contact-container">
      <h1 className="contact-title">Contact Us</h1>

      <div className="contact-grid">

        <div className="contact-card">
          <h3>Contact Details</h3>

          {contact?.phone && (
            <p className="contact-text">
              📞 <a className="contact-link" href={`tel:${contact.phone}`}>
                {contact.phone}
              </a>
            </p>
          )}

          {contact?.email && (
            <p className="contact-text">
              ✉️ <a className="contact-link" href={`mailto:${contact.email}`}>
                {contact.email}
              </a>
            </p>
          )}

          {contact?.address && (
            <p className="contact-text">
              📍 {contact.address}
            </p>
          )}
        </div>

        <div className="contact-card map-card">
          <h3>Location</h3>
          <p className="contact-text">
            📍 <a href={locationMapLink} target="_blank" rel="noopener noreferrer" className="contact-link">
              {locationName}
            </a>
          </p>
          <iframe
            title="ngo-location-map"
            className="map-frame"
            src={`https://maps.google.com/maps?q=${encodeURIComponent(locationName)}&z=14&output=embed`}
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>

      </div>

      <footer className="contact-footer">
        © {new Date().getFullYear()} SRV NGO. All rights reserved.
      </footer>
    </div>
  );
}